module.exports = __webpack_public_path__ + "static/machine_learning_01-aa007538021bd41b8d7d41f766238988.jpg";